/* eslint-disable react/no-danger */
import React from 'react';
import useStyles from './HighlightText.styles';

interface Props {
  /** String to add highlighs to */
  string: string;
  /** Substring to highlight inside string  */
  toMatch: string;
}

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const HighlightText = (props: Props) => {
  const { string, toMatch } = props;

  const classes = useStyles(props as any);
  const regex = new RegExp(`${escapeRegExp(toMatch)}`, 'i'); // first case in-sensitive match
  const match = string.match(regex);

  const getHighlightedString = () => {
    const [prefix, ...suffix] = string.split(match[0]);

    return (
      <span className={classes.highlight}>
        {prefix}
        <span data-qa="option-mask">{match[0]}</span>
        {suffix.join(match[0])}
      </span>
    );
  };

  return match && match[0] !== '' ? getHighlightedString() : <>{string}</>;
};

export default HighlightText;
